import React from "react";
import styles from "./GenericFHIRViewerModal.module.css";

const formatDate = (dateStr) => {
    if (!dateStr) return "Unknown";
    return new Date(dateStr).toLocaleDateString();
};

const CarePlanCardExtended = ({ resource }) => {
    if (!resource) return <div>No CarePlan data available.</div>;

    const title = resource.title || "Care Plan";
    const status = resource.status || "Unknown";
    const intent = resource.intent || "Unknown";
    const period = resource.period || {};
    const subject = resource.subject?.display || resource.subject?.reference || "Unknown";
    const author = resource.author?.display || resource.author?.reference || "Unknown";
    const addresses = resource.addresses?.map(addr => addr.display || addr.reference).join(", ") || "None";
    const categories = resource.category?.map(cat =>
        cat.coding?.map(code => code.display || code.code).join(", ")
    ).join(", ") || "None";
    const activities = resource.activity?.length
        ? resource.activity.map((act, idx) => {
            const detail = act.detail || {};
            return (
                <div key={idx} className="mb-2">
                    <strong>{detail.code?.text || detail.code?.coding?.[0]?.display || "Activity"}</strong>
                    {detail.status && <> — <span className="text-muted">{detail.status}</span></>}
                    {detail.description && <div className="ps-3">{detail.description}</div>}
                </div>
            );
        })
        : [<div key="none">None listed</div>];

    return (
        <div className="p-4 border rounded shadow-sm bg-white">
            {/* Header */}
            <div className="mb-3">
                <h3 className="mb-1">{title}</h3>
                <div className="mb-1 text-muted"><strong>CarePlan ID:</strong> {resource.id}</div>
                <div className="mb-1 text-muted"><strong>Status:</strong> {status}</div>
                <div className="mb-1 text-muted"><strong>Intent:</strong> {intent}</div>
                <div className="mb-1 text-muted">
                    <strong>Period:</strong> {formatDate(period.start)} - {formatDate(period.end)}
                </div>
            </div>

            {/* Subject & Author */}
            <div className={styles.sectionHeader}>Subject & Author</div>
            <div className="ps-5 pt-2">
                <div className="mb-1"><strong>Subject:</strong> {subject}</div>
                <div className="mb-1"><strong>Author:</strong> {author}</div>
            </div>

            {/* Categories */}
            <div className={styles.sectionHeader}>Categories</div>
            <div className="ps-5 pt-2">
                <div className="mb-1">{categories}</div>
            </div>

            {/* Addresses */}
            <div className={styles.sectionHeader}>Addresses</div>
            <div className="ps-5 pt-2">
                <div className="mb-1">{addresses}</div>
            </div>

            {/* Activities */}
            <div className={styles.sectionHeader}>Activities</div>
            <div className="ps-5 pt-2">
                {activities}
            </div>

            {/* Description */}
            {resource.description && (
                <>
                    <div className={styles.sectionHeader}>Description</div>
                    <div className="ps-5 pt-2">
                        <div className="mb-1">{resource.description}</div>
                    </div>
                </>
            )}
        </div>
    );
};

export default CarePlanCardExtended;